<template>
  <LKProgressCircular
    v-if="isLoadingAsyncData"
    overlay
    :size="50"
    style="align-items: start; padding-top: 30vh;"
  />
  <div v-else>
    <LKRoadmapsExpertsHeader
      name="Оценка меры"
      :readonly="isReadonly"
      @close="onClose"
      @save="onSave"
      @delete="onDelete"
      @save-close="onSaveAndClose"
    />

    <LKRoadmapsExpertsCriteria
      v-for="criteria in criterions"
      :key="criteria.id"
      :readonly="isReadonly"
      :criteria="criteria"
    />
  </div>
</template>

<script>
import LKProgressCircular from '@/components/lk/LKProgressCircular.vue'
import LKRoadmapsExpertsHeader from './components/LKRoadmapsExpertsHeader.vue'
import LKRoadmapsExpertsCriteria from './components/LKRoadmapsExpertsCriteria.vue'

import { LK_ROADMAPS_EXPERTS_ROUTES } from './utils'
import { LK_ROADMAPS_FEED_ROUTES as ROUTES } from '../LKRoadmapsFeed/utils'

import { createModalConfirm } from '@/helpers/createModalConfirm'
import { LkRoadmapExpertsFormApi } from '@/api/resources/LK/Roadmap/Experts/Form'

export default {
  $_veeValidate: {
    /** @type 'new' */
    validator: 'new',
  },
  components: {
    LKProgressCircular,
    LKRoadmapsExpertsHeader,
    LKRoadmapsExpertsCriteria,
  },
  data: () => ({
    isLoadingAsyncData: false,
    criterions: [],
  }),
  computed: {
    isReadonly() {
      return this.$route.name === LK_ROADMAPS_EXPERTS_ROUTES.LAYOUT_READONLY
    },
    eventId() {
      if (this.isReadonly) {
        return this.$route.params.id
      }
      return this.$route.query.eventId
    },
  },
  methods: {
    async asyncData() {
      const { eventId } = this
      if (!eventId) return

      this.isLoadingAsyncData = true

      try {
        const api = new LkRoadmapExpertsFormApi()
        const { criterions } = await api.getForm(eventId)
        if (Array.isArray(criterions)) {
          this.criterions = criterions
        }
      } catch (e) {
        this.$notice.errors(e)
      } finally {
        this.isLoadingAsyncData = false
      }
    },
    async onSaveAndClose(callback) {
      if (await this.onSave(callback)) {
        this.onClose()
      }
    },
    async onSave(callback) {
      const { eventId } = this
      if (!eventId) return false

      if (!await this.$validator.validate()) {
        return false
      }

      callback?.()
      const api = new LkRoadmapExpertsFormApi()

      let result = false
      try {
        const marks = this.criterions
          .map((el) => el.parameters)
          .flat()
          .map((parameter) => ({
            value: parameter.value,
            comment: parameter.comment,
            parameter_id: parameter.id,
          }))
        await api.save(eventId, {
          marks,
        })
        result = true
      } catch (e) {
        this.$notice.errors(e)
      }
      callback?.()
      return result
    },
    async onDelete(callback) {
      const modal = await createModalConfirm(this, {
        titleText: 'Ваши баллы будут удалены',
        action: async () => {
          await this.onDeleteConfirm(callback)
          modal.close()
        },
      })
      await modal.open()
    },
    async onDeleteConfirm(callback) {
      const { eventId } = this
      if (!eventId) return

      callback?.()

      try {
        const api = new LkRoadmapExpertsFormApi()

        await api.needExpertise(eventId)
        this.$nextTick(() => {
          this.onClose()
        })
      } catch (e) {
        this.$notice.errors(e)
      }

      callback?.()
    },
    onClose() {
      // this.$router.back()
      const { eventId } = this
      this.$router.push({
        name: ROUTES.LIST,
        params: {
          eventId,
        },
      })
    },
  },
}
</script>
